import { AUTH_URL } from '../../common/config/config';

const AuthFactory = function AuthFactory($http) {
  'ngInject';

  function saveAuthCredentials({ user, token }) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
  }
  function getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
  function signIn({ credentials, password }) {
    return $http
      .post(AUTH_URL, { username: credentials, password, isAdmin: true })
      .then(({ data }) => saveAuthCredentials({ user: data.user, token: data.token }));
  }
  function clear() {
    localStorage.clear();
  }
  function getToken() {
    return localStorage.getItem('token');
  }
  function isAuthenticate() {
    return !!getToken();
  }
  function logOut() {
    clear();
  }

  return {
    signIn,
    getUser,
    isAuthenticate,
    getToken,
    logOut,
  };
};

export default AuthFactory;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.factory.js